import Button from '@ui/buttons/Button'
import { ErpFrame } from '@ca/common'
import { getShResult } from '@ca/common/types'

import { OrderFrame } from '@order/orderTypes'
import { View } from 'react-native'
import { FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import FrameSettingsForm from './FrameSettingsForm'
import useFrameSettingsForm from './useFrameSettingsForm'
import useSaveFrame from './useSaveFrame'
import useStartOrderConfig from '@order/hooks/useStartOrderConfig'
import ButtonsFixed from '@ui/buttons/ButtonsFixed'
import Header from '@ui/elements/Header'
import Page from '@shell/Page'
import ConfigDebugModal from 'features/debug/ConfigDebugModal'

interface Props {
  frame: OrderFrame | ErpFrame
}

export const FrameSettingsPage = ({
  children,
}: {
  children?: React.ReactNode
}) => {
  const { t } = useTranslation(['ui', 'frame'])
  const text = 'frame:settings'

  return (
    <Page stage="frame">
      <Header
        title={t(`${text}.header.title`)}
        desc={t(`${text}.header.desc`)}
      />
      <View className="flex flex-col gap-8 px-8 pb-16">{children}</View>
    </Page>
  )
}

const FrameSettingsContent = (props: Props) => {
  const { t } = useTranslation(['ui', 'common', 'frame'])

  const { frame } = props

  // TODO: Switch this to a new method that checks if we need temples
  // true - go to temples
  // false - go to prescription
  const { goToTempleSelect } = useStartOrderConfig()

  const formProps = useFrameSettingsForm(frame)

  const { form } = formProps

  const saveFrame = useSaveFrame({
    onMutate: goToTempleSelect,
  })

  const onSubmit = form.handleSubmit((values) => {
    if (!frame.id) return

    const x = values.extend_x
    const y = values.extend_y

    saveFrame.save({
      frameId: frame.id,
      measurement: getShResult(Number(values.leftSH), Number(values.rightSH))
        .faceMeasurements,
      extend_x: x ? `${x}` : null,
      extend_y: y ? `${y}` : null,
    })
  })

  return (
    <>
      <FormProvider {...form}>
        <FrameSettingsPage>
          <FrameSettingsForm {...formProps} />
        </FrameSettingsPage>
        <ButtonsFixed>
          <Button
            variant="filled"
            onPress={onSubmit}
            label={t('ui:nextStep')}
            iconEnd="arrow-narrow-right"
          />
        </ButtonsFixed>
      </FormProvider>
      <ConfigDebugModal />
    </>
  )
}

export default FrameSettingsContent
